import { TComponentConfig, TTimeRangeOptionsItem } from '../types';
import { timeRangeOptions } from '../constants/timeRange';
import { getSingleSelectDefaultValue } from '../utils'; 
import TimeRangeSelect, { TimeRangeSelectType } from '../widgets/TimeRange';

function filterTimeRange(options: TTimeRangeOptionsItem[], filterValue: any) {
  return options.filter(item => {
    // 过滤 channels
    if (item.channels && filterValue.channels) {
      if (!item.channels.includes(filterValue.channels)) {
        return false;
      }
    }
    // 过滤 sources
    if (item.sources && filterValue.source) {
      if (!item.sources.includes(filterValue.source)) {
        return false;
      }
    }
    return true;
  });
}

export const TimeRange: TComponentConfig<TimeRangeSelectType> = {
  Component: TimeRangeSelect,
  defaultValue: (filterValue: any, props: TimeRangeSelectType) => {
    const {filterOptions, options, valueKeys: key} = props;
    const list = filterOptions(options, filterValue);
    return getSingleSelectDefaultValue(filterValue, key, list);
  },
  props: {
    title: 'Time Range',
    titleCn: '时间范围',
    valueKeys: 'time_range',
    filterOptions: filterTimeRange,
    options: timeRangeOptions,
  },
};
